'use strict';

exports.__esModule = true;
exports.default = getQueryName;
function getQueryName(route) {
  if (process.env.NODE_ENV !== 'production') {
    var query = route.query;

    if (query && query.modern) {
      query = query.modern;
    }

    if (typeof query === 'function') {
      return query().name;
    }
  }

  return 'UNKNOWN';
}
module.exports = exports['default'];